module.exports = __webpack_public_path__ + "img/mask.a1930ca0.jpg";